class BxfAccordionConstants {
    static STRING = {
        BXF_ACCORDION_EXPANSION_PANEL: 'BXF-ACCORDION-EXPANSION-PANEL',
        BXF_ACCORDION_EXPANSION_PANEL_DIV: 'bxf-accordion-expansion-panel',
        ERROR_MESSAGE: 'Tags other than bxf-accordion-expansion-panel are not supported within bxf-accordion',
        TEXT: '#text',
        BORDER: 'bxf-accordion__border',
        BXF_EXPANSION_PANEL_CONTAINER: 'bxf-accordion-expansion-panel__container',
        BXF_EXPANSION_PANEL_HEADER: 'bxf-accordion-expansion-panel__header',
        FACETED_FILTER_SUFFIX: '-faceted-filter',
        // avoid circular dependency with faceted filter
        FACETED_FILTER_TAGNAME: 'bxf-faceted-filter',
        FACETED_FILTER_OPTION_TAGNAME: 'bxf-faceted-filter-option',
        BUTTON: 'button',
    };
}

export { BxfAccordionConstants as B };
